export const getItemsFromSnapshot = async snapshot => {
  let items = [];
  snapshot.forEach(async doc => {
    const data = await doc.data();
    data.id = doc.id;
    items.push(data)
  });
  return items;
}